import { render } from "./vendor.scanner.vue?vue&type=template&id=084faa95"
import script from "./vendor.scanner.vue?vue&type=script&lang=js"
export * from "./vendor.scanner.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/tractus.web.clientapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__